import React, { useState, useEffect } from 'react'
import { X, Download, Share } from 'lucide-react'
import { usePwaInstall } from '../hooks/usePwaInstall'
import './InstallBanner.css'

export default function InstallBanner() {
    const { isInstallable, isStandalone, isIOS, promptInstall } = usePwaInstall()
    const [isVisible, setIsVisible] = useState(false)
    const [dismissed, setDismissed] = useState(() => localStorage.getItem('pwa-prompt-dismissed') === 'true')

    useEffect(() => {
        if (isInstallable && !isStandalone && !dismissed) {
            // Show with a slight delay for better UX
            const timer = setTimeout(() => setIsVisible(true), 2000)
            return () => clearTimeout(timer)
        }
    }, [isInstallable, isStandalone, dismissed])

    const handleDismiss = () => {
        setIsVisible(false)
        localStorage.setItem('pwa-prompt-dismissed', 'true')
        setDismissed(true)
    }

    const handleInstall = async () => {
        if (isIOS) {
            // iOS instructions are in the banner itself
            return
        }
        await promptInstall()
        setIsVisible(false)
    }

    if (!isVisible) return null

    return (
        <div className={`install-banner-container ${isVisible ? 'visible' : ''}`}>
            <div className="install-banner glass">
                <div className="install-banner-icon">
                    <img src="/favicon.svg" alt="SecureBlob" />
                </div>
                <div className="install-banner-content">
                    <h3 className="install-banner-title">Installera SecureBlob</h3>
                    <p className="install-banner-text">
                        {isIOS
                            ? 'Tryck på Dela-ikonen och välj "Lägg till på hemskärmen"'
                            : 'Använd SecureBlob som en snabb, säker app direkt på din hemskärm.'}
                    </p>
                </div>
                <div className="install-banner-actions">
                    {isIOS ? (
                        <div className="ios-share-guide">
                            <Share size={20} className="ios-share-icon" />
                        </div>
                    ) : (
                        <button className="btn btn-primary install-btn" onClick={handleInstall}>
                            <Download size={16} />
                            Installera
                        </button>
                    )}
                    <button className="btn btn-icon dismiss-btn" onClick={handleDismiss} aria-label="Stäng">
                        <X size={18} />
                    </button>
                </div>
            </div>
        </div>
    )
}
